(ns renolit-roofing-service.layout.infinite-scroll
  (:require [reagent.core :as r]
            [renolit-roofing-service.layout.icon :as layout.icon]
            [renolit-roofing-service.util :as util]))

(defn- observer
  [current-page on-page-change-callback]
  (let [scroll-observer (atom nil)
        target-id (str (random-uuid))]
    (r/create-class
     {:component-did-mount
      (fn [_comp]
        (let [target (js/document.getElementById target-id)
              observer-opts #js {:threshold 0}
              callback-fn (fn [entries]
                            (let [entry (aget entries 0)
                                  visible? (.-isIntersecting entry)]
                              (when visible?
                                (util/execute-callback on-page-change-callback (inc current-page)))))
              observer (js/IntersectionObserver. callback-fn observer-opts)]
          (.observe observer target)
          (reset! scroll-observer observer)))
      :component-will-unmount
      (fn [_]
        (when @scroll-observer
          (.disconnect @scroll-observer)))
      :reagent-render
      (fn [_]
        [:div.infinite-scroll-observer
         [:div.infinite-scroll-observer__target
          {:id target-id}]])})))

(defn- loading-indicator
  []
  [:div.infinite-scroll-loading-indicator
   [layout.icon/icon
    {:key :load-more}]])

(defn main
  [{:keys [more-pages-available?] :as pagination} on-page-change]
  [:<>
   (cond
     more-pages-available?
     [observer (:page pagination) on-page-change]

     (nil? more-pages-available?)
     [loading-indicator])])
